import React from "react";
import { ErrorMessage } from "formik";

const Step4Facilities = ({
    values,
    setFieldValue,
    submitted,
    errors,
    state,
    toggleFacility,
}) => {
    return (
        <div className="step_tags step_tags1">
            <ul>
                {state?.facilitiesTypes &&
                    state?.facilitiesTypes.length > 0 &&
                    state?.facilitiesTypes?.map((val, index) => {
                        return (
                            <li
                                key={index}
                                onClick={() =>
                                    toggleFacility(
                                        val.eng_title,
                                        val.title,
                                        val.image_url,
                                        setFieldValue
                                    )
                                }
                                className={
                                    values.facilities.some(
                                        (item) => item.engname == val.eng_title
                                    )
                                        ? "active"
                                        : "step_item"
                                }
                            >
                                <div className="step_item">
                                    <img width={25} height={25} src={val.image_url} alt={val.eng_title} />
                                    <h3>{val.eng_title}</h3>
                                </div>
                            </li>
                        );
                    })}
            </ul>
            {submitted && errors.facilities && (
                <ErrorMessage
                    name="facilities"
                    component="div"
                    className="errorStyle"
                />
            )}
        </div>
    );
};

export default Step4Facilities;
